import { Menu, MenuItem } from '@mui/material';

function ActionsMenu({ anchorEl, handleCloseMenu, handleSubmitAction }: any) {
    return (
        <Menu
            anchorEl={anchorEl}
            open={!!anchorEl}
            onClose={handleCloseMenu}
            sx={{
                '& .MuiPaper-root': {
                    color: '#384A52',
                    width: '176px',
                    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.1)'
                },
                '& .delete': {
                    color: '#971B2F'
                },
                '& li:hover': {
                    background: '#E2ECF3'
                }
            }}
            MenuListProps={{
                'aria-labelledby': 'basic-button'
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            <MenuItem onClick={() => handleSubmitAction('view')}>Ver</MenuItem>
            <MenuItem onClick={() => handleSubmitAction('edit')}>Editar</MenuItem>
            <MenuItem onClick={() => handleSubmitAction('delete')} className="delete">
                Eliminar
            </MenuItem>
        </Menu>
    );
}

export default ActionsMenu;
